const AppRouter = [
    {
        path: "/",
        name: "Home",
        component: () => import("@/Views/HomePage.vue")
    },
    {
        path: "/About",
        name: "About",
        meta: {
            requireAuth: false
        },
        component: () => import("@/Views/AboutUs.vue")
    },
    {
        path: "/Products",
        name: "Products",
        meta: {
            requireAuth: false
        },
        component: () => import("@/Views/ProductsPage.vue")
    }, 
    {
        path: "/Order",
        name: "Order",
        meta: {
            requireAuth: false
        },
        component: () => import("@/Views/OrderPage.vue")
    },
    {
        path: "/ContactUs",
        name: "ContactUs",
        meta: {
            requireAuth: false
        },
        component: () => import("@/Views/ContactUs.vue")
    }             
]

export default AppRouter;